import React from 'react'
import { BlockComponent } from 'lib'
import { FavoriteArticlesCardView } from './ArticleList'
import { EmptyState } from './EmptyState'
import { LoadingBoundary } from 'components/patterns/suspense/Suspense'
import { buildDashItem } from 'experiences/dashboard/DashboardRoot/lib/types'
import { ClientOnlyRender } from 'lib/renderWrappers/ClientOnly'
import { useFavorites } from 'stores/Favorites'

/**
 * Note this component requires a {@link FavoritesContainer | FavoritesContainer} to work
 * @constructor
 */
export const FavoriteArticlesCard: BlockComponent = () => {
	const [favorites] = useFavorites()

	return (
		<ClientOnlyRender>
			<LoadingBoundary fallback={<div />} errorState={() => <EmptyState />}>
				<FavoriteArticlesCardView favorites={favorites} />
			</LoadingBoundary>
		</ClientOnlyRender>
	)
}

export const favoriteArticlesItem = buildDashItem(<FavoriteArticlesCard />, 'card', 2)
